import React from 'react';
import {
    TableRow,
    TableCell,
    Checkbox,
    IconButton,
    Typography,
    Chip,
    Box,
} from '@mui/material';
import { MoreVert as MoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import ChannelBadge from './ChannelBadge';

const LOCALE_LABELS = {
    en: { en: 'English', ar: 'الإنجليزية' },
    ar: { en: 'Arabic',  ar: 'العربية' },
};

const NotificationTemplatesTableRow = ({
    template,
    index,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const localeMeta = LOCALE_LABELS[template.locale];
    const localeLabel = template.locale
        ? (isArabic ? localeMeta?.ar : localeMeta?.en) || template.locale
        : (isArabic ? 'الافتراضي' : 'Default');

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, template.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align="start">{index + 1}</TableCell>

            {/* Code */}
            <TableCell>
                <Typography variant="body2" fontWeight="bold" sx={{ color: 'primary.main', fontFamily: 'monospace' }}>
                    {template.code}
                </Typography>
            </TableCell>

            {/* Channel */}
            <TableCell align="center">
                <ChannelBadge channel={template.channel} />
            </TableCell>

            {/* Locale */}
            <TableCell align="center">
                <Typography variant="caption" sx={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
                    {localeLabel}
                </Typography>
            </TableCell>

            {/* Subject */}
            <TableCell>
                <Box sx={{ maxWidth: 320 }}>
                    <Typography variant="body2" noWrap title={template.subject || ''}>
                        {template.subject || (
                            <Typography component="span" variant="body2" color="text.disabled" sx={{ fontStyle: 'italic' }}>
                                {isArabic ? 'بدون عنوان' : 'No subject'}
                            </Typography>
                        )}
                    </Typography>
                </Box>
            </TableCell>

            {/* Status */}
            <TableCell align="center">
                <Chip
                    label={
                        template.is_active
                            ? (isArabic ? 'نشط' : 'Active')
                            : (isArabic ? 'متوقف' : 'Inactive')
                    }
                    size="small"
                    color={template.is_active ? 'success' : 'default'}
                    variant="tonal"
                    sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: 80 }}
                />
            </TableCell>

            {/* Updated */}
            <TableCell align="center">
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                    {template.updated_at ? dayjs(template.updated_at).format('YYYY-MM-DD') : '-'}
                </Typography>
            </TableCell>

            {/* Actions */}
            <TableCell align="center">
                <IconButton size="small" onClick={(e) => onMenuOpen(e, template)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default NotificationTemplatesTableRow;
